export const getMinBookingTime = (value, type) => {
  if (value === undefined) { return undefined }

  const parsedValue = parseFloat(value)
  if (type === 'mins') return parsedValue * 60
  if (type === 'hours') return parsedValue * 60 * 60
  return parsedValue * 60 * 60 * 24
}
